// src/features/suppliers/pages/SuppliersPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const StockCategoriesPage = () => {
  return <MasterDataListPage type="categories" />;
};

export default StockCategoriesPage;